import "./scss/components-library.scss";

export namespace ComponentsLib {
    export interface ILightbox {
        init(): void;
    }

    export class Lightbox implements ILightbox {
        whiteList = [];
        openButtonSelector: string;
        whiteListSelector: string;

        constructor(openButtonSelector: string, whiteListSelector: string) {
            this.openButtonSelector = openButtonSelector;
            this.whiteListSelector = whiteListSelector;
        }

        initWhiteList(): void {
            $(this.whiteListSelector).each((index, item) => {
                this.whiteList.push($(item).data("lightbox-white-list"));
            });
        }

        initFromQueryString(queryString: string): void {
            const queries = queryString.split("&");
            queries.forEach((indexQuery: string) => {
                const indexPair = indexQuery.split("=");

                const queryKey = decodeURIComponent(indexPair[0]);
                const queryValue = decodeURIComponent(indexPair.length > 1 ? indexPair[1] : "");

                if (queryKey == "openInLightbox") {
                    this.openLightbox(queryValue);
                }
            });
        }

        init(): void {
            this.initWhiteList();
            this.initFromQueryString(window.location.search.substring(1));
            $(this.openButtonSelector).each((index, item) => {
                const openButton = $(item);
                openButton.on("click",
                    (event) => {
                        const contentUrl = openButton.data("lightbox-href");
                        this.openLightbox(contentUrl);
                    });
            });
        }

        closeLightbox(closeButton: JQuery<Element>, iframe: JQuery<Element>, blackRow: JQuery<Element>, lightbox: JQuery<Element>) {
            closeButton.animate({ 'right': '-100vw' }, 200);
            iframe.animate({ 'right': '-100vw' }, 400, () => {
                $("body").removeClass("lightbox-open");
                blackRow.animate({ 'margin-top': '50vh', 'margin-bottom': '50vh' }, 150, () => {
                    lightbox.remove();
                });
            });
        }

        private validateUrl(contentUrl: string): boolean {
            let urlToSearch = "";
            try {
                const url = new URL(contentUrl);
                urlToSearch = url.origin;
            } catch {
                urlToSearch = contentUrl;
            }
            return this.whiteList.some(x => x === urlToSearch);
        }

        private mainAppUrlProcess(contentUrl: string): string {
            const parameter = "mainApplicationUrl";
            let url: URL;

            try {
                url = new URL(contentUrl);
            }
            catch {
                if (this.whiteList.some(x => x === contentUrl)) {
                    return contentUrl;
                }
                throw "invalid url";
            }

            if (url.searchParams.has(parameter)) {
                return contentUrl;
            }

            let locationOrigin = window.location.origin;
            if (!locationOrigin.endsWith('/')) {
                locationOrigin += '/';
            }
            url.searchParams.append(parameter, locationOrigin);

            return url.toString();
        }

        openLightbox(contentUrl: string) {
            if (!this.validateUrl(contentUrl)) {
                return;
            }

            contentUrl = this.mainAppUrlProcess(contentUrl);

            const lightbox = $(`<div class=\"lightbox overlay\"></div>
<section class="lightbox">
    <div class=\"lightbox full-screen\">
        <div class="container">
            <div class="lightbox-close">
                <i class="material-icons-outlined double_arrow" aria-hidden="true"></i>
            </div>
            <iframe src=\"${contentUrl}\" allowtransparency="true"></iframe>
        </div>
    </div>
</section>`);

            const iframe = lightbox.find("iframe");
            const blackRow = lightbox.find(".lightbox.full-screen");

            const closeButton = lightbox.find(".lightbox-close");
            closeButton.on("click", () => {
                this.closeLightbox(closeButton, iframe, blackRow, lightbox);
            });

            lightbox.on("click", () => {
                this.closeLightbox(closeButton, iframe, blackRow, lightbox);
            });

            $("body").addClass("lightbox-open");
            $("body").append(lightbox);

            blackRow.animate({ 'margin-top': '12vh', 'margin-bottom': '12vh' }, 150, () => {
                iframe.animate({ 'right': '0px' }, 400, () => {
                });
                closeButton.animate({ 'right': '0px' }, 500);
            });
        }
    }

    export interface IMessagePanel {
        init(): void;
    }

    export class MessagePanel implements IMessagePanel {
        messagePanel: JQuery;
        resultAction: any;
        monitor: JQuery;
        statusUrl: string;
        monitorName: string;

        constructor(messagePanel: JQuery, resultAction: (data: string | boolean, messagePanel: JQuery, value: string) => void) {
            this.messagePanel = messagePanel;
            this.resultAction = resultAction;
        }

        init(): void {
            if (this.messagePanel.length === 0) {
                return;
            }

            this.statusUrl = this.messagePanel.data("query-url");
            this.monitorName = this.messagePanel.data("monitor-name");
            const monitorSelector = this.messagePanel.data("monitor");
            this.monitor = $(monitorSelector);
            this.monitor.change(() => {
                this.checkStatus();
            });
            this.checkStatus();
        }

        checkStatus() {
            const data: any = {};
            const monitorValue = this.monitor.val();
            data[this.monitorName] = monitorValue;
            $.ajax({
                url: this.statusUrl,
                type: 'GET',
                data: data,
                contentType: false, // tell jQuery not to set contentType
            }).done((data) => this.resultAction(data, this.messagePanel, monitorValue));
        }
    }

    export interface ISubmitDialog {
        initDialog(): void;
        assureInit(): void;
    }

    export class SubmitDialog implements ISubmitDialog {
        confirmButtonReady = false;

        assureInit(): void {
            if (!this.confirmButtonReady) {
                $("[data-confirm-submit=\"true\"]").click(function () {
                    const formSelector = $($(this).parents(".modal")).data("form");
                    $(formSelector).submit();
                });
                this.confirmButtonReady = true;
            }

            const items = $("[data-confirm-submit-form=\"true\"]");
            items.click(function () {
                const target = $(this).data("target");
                const id = $(this).data("confirm-id");
                $(target).data("form", $(this).data("form"));
                $(target).find("[data-id=\"true\"]").text(id);
            });

            items.attr("data-confirm-submit-form", "false");
        }

        initDialog(): void {
            this.assureInit();

            const buttons = $("[data-ajax-form=\"true\"]");
            buttons.click(function () {
                const target = $(this).data("target");
                const id = $(this).data("ajax-id");
                $(target).find("[data-id=\"true\"]").val(id);
                $(target).find("[data-click-on-open=\"true\"]").click();
            });
            buttons.attr("data-ajax-form", "false");
        }
    }

    export interface IRadioSelector {
        init(): void;
    }

    export class RadioSelector implements IRadioSelector {
        radioSelector: string;
        selectedClass = "selected";

        constructor(radioSelector: string) {
            this.radioSelector = radioSelector;
        }

        init(): void {
            $(this.radioSelector).on("click",
                (event) => {
                    const target = $(event.target);
                    let radioSelector = target.parents(this.radioSelector);
                    if (radioSelector.length === 0) {
                        radioSelector = target;
                    }
                    radioSelector.parent().find(`.${this.selectedClass}`).removeClass(this.selectedClass);
                    radioSelector.addClass(this.selectedClass);

                    const radio = radioSelector.find("input[type=radio]");
                    const checked = radio.prop("checked");
                    if (checked) {
                        return;
                    }
                    radio.prop("checked", true).change();
                }
            );
        }
    }

    export interface IShowButton {
        init(): void;
    }

    export class ShowButton implements IShowButton {
        buttonSelector: string;
        selectedClass = "selected";

        constructor(buttonSelector: string) {
            this.buttonSelector = buttonSelector;
        }

        init(): void {
            $(this.buttonSelector).on("click",
                (event) => {
                    var targetSelector = $(event.target).data("show-button");
                    const target = $(targetSelector);

                    if (target.hasClass("show")) {
                        target.slideUp(500);
                        target.removeClass("show");
                    } else {
                        target.slideDown(500);
                        target.addClass("show");
                    }
                }
            );
        }
    }

    export interface IDisableCheckbox {
        init(): void;
    }

    export class DisableCheckbox implements IDisableCheckbox {
        buttonSelector: string;

        constructor(buttonSelector: string) {
            this.buttonSelector = buttonSelector;
        }

        init(): void {
            $(this.buttonSelector).on("click",
                (event) => {
                    this.Process($(event.target));
                }
            );
            this.Process($(this.buttonSelector));
        }

        Process(target: JQuery): void {
            const checked = target.is(":checked");
            var targetSelector = target.data("disable-target");

            if (checked) {
                $(targetSelector).prop("disabled", true);
            } else {
                $(targetSelector).prop("disabled", false);
            }
        }
    }

    export interface IEnableCheckbox {
        init(): void;
    }

    export class EnableCheckbox implements IEnableCheckbox {
        buttonSelector: string;

        constructor(buttonSelector: string) {
            this.buttonSelector = buttonSelector;
        }

        init(): void {
            $(this.buttonSelector).on("click",
                (event) => {
                    this.Process($(event.target));
                }
            );
            $(this.buttonSelector).each((index, item) =>
                this.Process($(item))
            );
        }

        Process(target: JQuery): void {
            const checked = target.is(":checked");
            var targetSelector = target.data("enable-target");

            if (checked) {
                $(targetSelector).prop("disabled", false);
            } else {
                $(targetSelector).prop("disabled", true);
            }
        }
    }

    export interface IDatePanel {
        init(): void;
    }

    export class DatePanel implements IDatePanel {

        constructor() {
        }

        init(): void {
            $("[data-user-time]").each(
                (index, item) => {
                    const date = $(item).data("user-time");
                    const locale = $(item).data("locale");
                    //@ts-ignore
                    const displayDate = new Intl.DateTimeFormat(locale, { dateStyle: 'short', timeStyle: 'medium' }).format(new Date(date));
                    $(item).html(displayDate);
                }
            );
        }
    }

    export interface IRandomTextButton {
        init(): void;
    }

    export class RandomTextButton implements IRandomTextButton {

        constructor() {
        }

        randomObjectId(): string {
            const h = 16;
            const s = function (arg: number) {
                return Math.floor(arg).toString(h).toUpperCase();
            };
            const initialString: any = " ";
            return initialString.repeat(8).replace(/./g, function () {
                return s(Math.random() * h);
            });
        }

        init(): void {
            $("[data-generate-random]").each(
                (index, item) => {
                    $(item).on("click", () => {
                        $($(item).data("generate-random")).val(this.randomObjectId())
                    });
                }
            );
        }
    }

    export interface IEmptyTextButton {
        init(): void;
    }

    export class EmptyTextButton implements IEmptyTextButton {

        constructor() {
        }

        init(): void {
            $("[data-empty]").each(
                (index, item) => {
                    $(item).on("click", () => {
                        $($(item).data("empty")).val("");
                    });
                }
            );
        }
    }

    export interface ISetTextCheckbox {
        init(): void;
    }

    export class SetTextCheckbox implements ISetTextCheckbox {
        checkboxSelector: string;

        constructor(checkboxSelector: string) {
            this.checkboxSelector = checkboxSelector;
        }

        init(): void {
            $(this.checkboxSelector).on("click",
                (event) => {
                    this.Process($(event.target));
                }
            );
            this.Process($(this.checkboxSelector));
        }

        Process(target: JQuery): void {
            const checked = target.is(":checked");
            var targetSelector = target.data("text-target");

            if (checked) {
                $(targetSelector).text(target.data("text-checked"));
            } else {
                $(targetSelector).text(target.data("text-unchecked"));
            }
        }
    }

    export interface IToggleCheckbox {
        init(): void;
    }

    export class ToggleCheckbox implements IToggleCheckbox {
        checkboxSelector: string;

        constructor(checkboxSelector: string) {
            this.checkboxSelector = checkboxSelector;
        }

        init(): void {
            $(this.checkboxSelector).on("change",
                (event) => {
                    this.Process($(event.target));
                }
            );
            this.Process($(this.checkboxSelector));
        }

        Process(target: JQuery): void {
            const reverse = target.data("reverse");
            const checked = target.is(":checked");
            var targetSelector = target.data("toggle-target");
            if (reverse) {
                $(targetSelector).toggle(!checked);
            } else {
                $(targetSelector).toggle(checked);
            }
        }
    }

    $['jMaskGlobals'] = {
        translation: {
            'Z': {
                pattern: /./, optional: true
            }
        }
    };

    export interface IMaskInput {
        handleDynamicCountry(form: JQuery<HTMLElement>): void;
    }

    export class MaskInput implements IMaskInput {
        handleDynamicCountry(form: JQuery<HTMLElement>): void {
            const taxNumberOptionsSelector = "mask-taxnumber-options";
            const postCodeOptionsSelector = "mask-postcode-options";
            const countrySelector = "mask-country";
            const taxNumberSelector = "mask-taxnumber";
            const postCodeSelector = "mask-postcode";

            const taxNumberMaskData = form.find(`[data-${taxNumberOptionsSelector}]`);
            const postCodeMaskData = form.find(`[data-${postCodeOptionsSelector}]`);
            const selectedCountries = form.find(`[data-${countrySelector}]`);

            attachMaskEvents(taxNumberMaskData, taxNumberOptionsSelector, taxNumberSelector);
            attachMaskEvents(postCodeMaskData, postCodeOptionsSelector, postCodeSelector);

            function attachMaskEvents(mask: any, maskSelector: string, inputSelector: string) {
                if (mask.length > 0) {
                    const taxNumberMask = mask.data(maskSelector);
                    const countryQty = selectedCountries.length;
                    selectedCountries.each(function () {
                        const selectedCountry = $(this);
                        setMask(countryQty, selectedCountry, inputSelector, taxNumberMask);
                        selectedCountry.on('change', function () {
                            setMask(countryQty, selectedCountry, inputSelector, taxNumberMask);
                        });
                    });
                }
            }

            function setMask(countryQty: number, countryDropdown: JQuery<HTMLElement>, selector: string, mask: any) {
                const inputs = form.find(`[data-${selector}]`);
                const currentCountry = countryDropdown.find(":selected").val().toString();
                const currentMask = mask[currentCountry];

                if (countryQty > 1) {
                    const countryIdx = countryDropdown.data(countrySelector);

                    inputs.each(function () {
                        const input = $(this);
                        const inputIdx = input.data(selector);

                        if (countryIdx === inputIdx) {
                            input.mask(currentMask);
                        }
                    });
                } else {
                    inputs.each(function () {
                        $(this).mask(currentMask);
                    });
                }
            }
        }
    }
}
